import React from 'react';
import { ComingSoonPage } from './ComingSoonPage';

function BillingPage() {
  return (
    <ComingSoonPage
      label="Billing"
      title="Plans & billing"
      description="Subscription management for your organisation."
      planned={[
        'Plan selection and seat management',
        'Usage-based metering for bundle storage and delivery',
        'Invoice history and payment methods',
      ]}
    />
  );
}

export { BillingPage };
